<template>
    <div class="lk_nav">
        <h1>Навигация</h1>
        <div class="nav_box">
            <ul>
                <router-link tag="li" to="/profile" :class="page === 'clientIndex' ? 'active':''">История</router-link>
                <router-link tag="li" to="/profile/edit" :class="page === 'clientProfile' ? 'active':''">Мои данные</router-link>
                <router-link tag="li" to="/profile/bonus" :class="page === 'clientBonus' ? 'active':''">Заработать бонусы</router-link>
                <router-link tag="li" to="/profile/referral" :class="page === 'clientReferral' ? 'active':''">Реферальная программа</router-link>
            </ul>
        </div>

    </div>
</template>

<script>
export default {
  name: 'navigate',
  data () {
    return {
      page: 'index'
    }
  },
  created () {
    this.page = this.$route.name
  },
  watch: {
    $route (to, from) {
      this.page = to.name
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/client/navigate.vue